import React from "react";
import { ROUTING_TYPE_CONFIG, RoutingTypeKey } from "src/constants/relabelCases";

interface RoutingTypeBadgeProps {
  routingType: string;
}

const RoutingTypeBadge: React.FC<RoutingTypeBadgeProps> = ({ routingType }) => {
  const config = ROUTING_TYPE_CONFIG[routingType as RoutingTypeKey];
  if (!config) return <span className="text-xs text-muted-foreground">{routingType}</span>;
  return (
    <span
      className={`inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium ${config.badgeBg} ${config.badgeText} border ${config.badgeBorder}`}
    >
      {config.label}
    </span>
  );
};

export { RoutingTypeBadge };
